import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidReadingBasisInstructionMode } from '../../../../mechanics/rid-reading-basis-instruction-mode/rid-reading-basis-instruction-mode';
import { injectQueryParams } from '../../../../utils/route.utils';

@Component({
  selector: 'app-reading-basis-instruction-mode-per-sound-page',
  imports: [RidReadingBasisInstructionMode],
  templateUrl: './reading-basis-instruction-mode-per-sound-page.html',
})
export class ReadingBasisInstructionModePerSoundPage {
  protected readonly $router = inject(Router);

  protected readonly queryParams = injectQueryParams();
  protected readonly pace = computed(() => parseInt(this.queryParams()['pace'] ?? '500'));
}
